<div class="flex flex-row justify-between items-center flex-nowrap px-4 sm:px-0">
  <h4 class="font-semibold text-xl mt-2 sm:mt-0">
    {{ '#WORKSHOP.DIALOGS.EDIT_HEADER.TITLE' | translate }}
  </h4>
  @if (loading$ | async) {
    <div class="flex flex-row justify-end items-center auto-width fill-height mt-3">
      <soft-loading-spinner class="spin small mr-2"></soft-loading-spinner>
      <span class="color-light small-font ml-1">{{
        '#WORKSHOP.SHARED.LOADING_INFO' | translate
      }}</span>
    </div>
  } @else {
    <div class="spacer"></div>
  }
</div>

<form [formGroup]="form" class="mt-3" (ngSubmit)="onSubmit()">
  <div class="flex flex-col px-4 sm:px-0">
    <soft-multiline-input formControlName="headerText" [lines]="4"></soft-multiline-input>
  </div>

  <div class="flex flex-row justify-between actions sm:gap-2 w-full flex-nowrap mt-3">
    <button
      class="soft-button h-14 w-full text-center secondary fill-force"
      (click)="close(null)"
    >
      {{ '#WORKSHOP.DIALOGS.ABORT' | translate }}
    </button>
    <button class="soft-button h-14 w-full text-center primary fill-force">
      {{ '#WORKSHOP.DIALOGS.SUBMIT_SAVE' | translate }}
    </button>
  </div>
</form>
